import { createSelector } from '@reduxjs/toolkit';
import { denormalize } from 'normalizr';
import { Booking, Selector } from 'shared/Redux/interfaces';
import { bookingsEntity } from 'shared/Redux/schemas';
import {
  bookingSelectors,
  consumerDivisionSelectors,
  consumerMemberSelectors,
  consumerSelectors,
  consumerTeamSelectors,
  dateSelectors,
  dateSeriesSelectors,
  eventSelectors,
  noteSelectors,
  occasionSelectors,
  seasonSelectors,
  unitSelectors
} from 'shared/Redux/slices';

export default function selectBookingById(id: string): Selector<Booking> {
  return createSelector(
    [
      bookingSelectors.selectEntities,
      occasionSelectors.selectEntities,
      consumerSelectors.selectEntities,
      consumerMemberSelectors.selectEntities,
      consumerTeamSelectors.selectEntities,
      consumerDivisionSelectors.selectEntities,
      unitSelectors.selectEntities,
      seasonSelectors.selectEntities,
      noteSelectors.selectEntities,
      eventSelectors.selectEntities,
      dateSeriesSelectors.selectEntities,
      dateSelectors.selectEntities
    ],

    (
      bookings,
      occasions,
      consumers,
      consumerMembers,
      consumerTeams,
      consumerDivisions,
      units,
      seasons,
      notes,
      events,
      dateSeries,
      dates
    ) => {
      const booking = bookings[id];

      const denormalized = denormalize(booking, bookingsEntity, {
        consumers,
        consumerMembers,
        consumerTeams,
        consumerDivisions,
        occasions,
        events,
        notes,
        units,
        seasons,
        dateSeries,
        dates
      });

      return denormalized;
    }
  );
}
